module.exports = __webpack_public_path__ + "static/logoWhite-ad2d913356046699104bd3c11a7f86c3.png";